import { uniqBy } from 'lodash';
import type { PackageFormValues } from '@/views/add-package/add-package.types';

export const getUniqueProducts = (products: PackageFormValues['products']) => {
    const selectedProducts = products?.flatMap(day => day.items);
    return uniqBy(selectedProducts, 'id');
};

export const calcDiscount = (
    discount: PackageFormValues['discount'],
    total: number
) => {
    const amount = Number.isFinite(discount.amount) ? discount.amount : 0;
    if (amount <= 0) return 0;

    if (discount.type === 'relative') {
        const pct = Math.min(amount, 100);
        return (total * pct) / 100;
    }

    return amount;
};
